import { KeyValue } from "@/main/models/common";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import {
	CompanyManufacturerRequest,
	CompanyManufacturerSaveRequest,
	DeleteCompanyManufacturerRequest,
} from "@/main/models/request/companyManufacturerRequest";
import { CompanyManufacturerResponse } from "@/main/models/response/companyManufacturerResponse";
import { AxiosResponse } from "axios";

export abstract class ICompanyManufacturerApi {
	abstract getCompanyManufacturerGrid(
		request: CompanyManufacturerRequest,
	): Promise<AxiosResponse<PaginationResponse<CompanyManufacturerResponse>>>;
	abstract saveCompanyManufacturers(
		request: CompanyManufacturerSaveRequest,
	): Promise<AxiosResponse<Result<CompanyManufacturerResponse[]>>>;
	abstract deleteCompanymanufacturer(
		request: DeleteCompanyManufacturerRequest,
	): Promise<AxiosResponse<Result<CompanyManufacturerResponse>>>;
	abstract getDomain(request: CompanyManufacturerRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
